import React, { FC } from 'react'
import Typography from '@mui/material/Typography'
import Chip from '@mui/material/Chip'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import ListItemText from '@mui/material/ListItemText'
import TodayIcon from '@mui/icons-material/Today'
import Box from '@mui/material/Box'

import {
  getDateTitle,
  getShortDayTitle,
  getDateDayOfWeek,
  getSlotTimeTitle,
  padTimeTitle,
  getDateString,
  getDaysFromDate,
} from '@kaidam/fc-shared/src/booking/utils'

import {
  IData_Calendar_Public_Day_Merged,
} from '@kaidam/fc-shared/src/types/schema/booking'

interface PublicCalendarProps {
  data: IData_Calendar_Public_Day_Merged[],
  length: number,
  latest: string,
  onSubmit: {
    (date: string): void
  }
}

const PublicCalendar: FC<React.PropsWithChildren<PublicCalendarProps>> = ({
  data,
  length,
  latest,
  onSubmit,
}) => {
  return (
    <Box sx={{
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'flex-start',
      width: '100%',
    }}>
      {
        data.map(day => {
          const afterLatest = getDaysFromDate(day.date, latest) > 0

          return (
            <Box
              key={day.date}
              sx={{
                width: '100%',
                maxWidth: '300px',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-start',
                justifyContent: 'center',
                border: '1px dashed #ccc',
                mx: 2,
                p: 2,
              }}
            >
              <Box sx={{
                width: '100%',
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
              }}>
                <Box sx={{ flexGrow: 1 }}>
                  <Chip
                    icon={<TodayIcon />}
                    label={`${getShortDayTitle(getDateDayOfWeek(day.date))} : ${getDateTitle(day.date)}`}
                  />
                </Box>
              </Box>
              <Box sx={{
                width: '100%',
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'flex-start',
              }}>
                <List sx={{ flexGrow: 1 }}>
                  {
                    afterLatest ? (
                      <ListItem
                        sx={{
                          border: '1px dashed #ccc',
                          mb: 1,
                        }}
                      >
                        <ListItemText
                          primaryTypographyProps={{
                            component: 'div'
                          }}
                          secondaryTypographyProps={{
                            component: 'div'
                          }}
                          primary={
                            <Typography variant="caption">
                              no available slots after {getDateTitle(latest)}
                            </Typography>
                          }
                        />
                      </ListItem>
                    ) : (
                      <>
                        {
                          day.slots.length <= 0 && (
                            <ListItem
                              sx={{
                                border: '1px dashed #ccc',
                                mb: 1,
                              }}
                            >
                              <ListItemText
                                primaryTypographyProps={{
                                  component: 'div'
                                }}
                                secondaryTypographyProps={{
                                  component: 'div'
                                }}
                                primary={
                                  <Typography variant="caption">
                                    no available slots on this day
                                  </Typography>
                                }
                              />
                            </ListItem>
                          )
                        }
                        {
                          day.slots.map(slot => {
                            const id = [slot.hour, slot.min].join(':')
                            return (
                              <ListItem
                                key={id}
                                button
                                sx={{
                                  border: '1px dashed #ccc',
                                  mb: 1,
                                }}
                                onClick={() => {
                                  onSubmit(`${day.date}T${padTimeTitle(slot.hour)}:${padTimeTitle(slot.min)}:00`)
                                }}
                              >
                                <ListItemText
                                  primaryTypographyProps={{
                                    component: 'div'
                                  }}
                                  secondaryTypographyProps={{
                                    component: 'div'
                                  }}
                                  primary={
                                    <Box sx={{
                                      display: 'flex',
                                      flexDirection: 'row',
                                      alignItems: 'center',
                                    }}>
                                      <Box sx={{ flexGrow: 1 }}>
                                        {getSlotTimeTitle(slot, length)}
                                      </Box>
                                    </Box>
                                  }
                                />
                              </ListItem>
                            )
                          })
                        }
                      </>
                    )
                  }
                </List>
              </Box>
            </Box>
          )
        })
      }
    </Box>
  )
}

export default PublicCalendar